import { ScriptTemplate } from '@/models/scriptTemplates'

export interface ScriptTemplatesState {
  scriptTemplates: ScriptTemplate[]
}

export const initialState: ScriptTemplatesState = {
  scriptTemplates: [],
}
